import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import molliesLogoRed from "images/Mollies_Ico_Red.svg";
import molliesLogoText from "images/mollies_logo_text.svg";
import sohoHouseLogo from "images/soho_house_logo.svg";

// Component for rendering the logo section

const LogoSection = ({ classes, isSohoMode, centerLogo, to = "/" }) => (
  <Link className={classes.logoContainer} to={to}>
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={1}>
      {isSohoMode && (
        <>
          <Grid item style={{ display: "flex" }}>
            <img
              className={classNames(
                classes.navbarMultiLogo,
                centerLogo ? classes.navbarLogoCentered : null
              )}
              src={sohoHouseLogo}
              alt="Soho Logo"
            />
          </Grid>
          <Grid item style={{ color: "black" }}>
            <AddIcon className={classes.plusIcon} />
          </Grid>
        </>
      )}
      <Grid item style={{ display: "flex" }}>
        <img
          className={classNames(
            isSohoMode ? classes.navbarMultiLogo : classes.navbarLogo,
            centerLogo ? classes.navbarLogoCentered : null
          )}
          src={isSohoMode ? molliesLogoText : molliesLogoRed}
          alt="Mollies Logo"
        />
      </Grid>
    </Grid>
  </Link>
);

LogoSection.propTypes = {
  classes: PropTypes.object.isRequired,
  isSohoMode: PropTypes.bool.isRequired,
  centerLogo: PropTypes.bool,
  to: PropTypes.string,
};

export default LogoSection;
